import { render, staticRenderFns } from "./alipayFreeze.vue?vue&type=template&id=bbee7174&scoped=true&"
import script from "./alipayFreeze.vue?vue&type=script&lang=js&"
export * from "./alipayFreeze.vue?vue&type=script&lang=js&"
import style0 from "./alipayFreeze.vue?vue&type=style&index=0&id=bbee7174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee7174",
  null
  
)

export default component.exports